export default {
  colors: {
    light: '#e5e5e5',
    main: '#F7E017',
    dark: '#d3d3d336',
    white30: '#ffffff30',
    blue: '#004899',
  },
}
